<template>
  <b-container id="mainContainer" class="primary-container" align-v="center">
    <b-row align-v="center" align-h="center">
      <b-col lg="6" xs="12">
        <b-card id="cardLogin" class="scale-in-bl card-contain">
          <img
            alt="Data Energy"
            v-bind:src="getLogoBase64"
            style="width:80%; margin-bottom: 20px;  max-width: 350px;"
          />

          <slot></slot>

          <div v-if="updateExists" class="appRefresh">
            <b-alert variant="warning" show>
              <div class="title">A new app version is available</div>
              <b-button variant="info" size="sm" @click="refreshApp"
                >Reload App</b-button
              >
            </b-alert>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { logoData } from "@/components/mixins/logo";
import { updateApp } from "@/components/mixins/update-app";

export default {
  name: "AuthTemplate",
  mixins: [logoData, updateApp]
};
</script>

<style scoped lang="scss">
.card-contain {
  border-radius: 12px;
  -webkit-box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);
  -moz-box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);
  box-shadow: 0px 10px 34px -15px rgba(0, 0, 0, 0.24);
}

.primary-container {
  margin-bottom: 30px;
}

.appRefresh {
  font-size: 14px;
  margin-top: 20px;
  .alert {
    border-radius: 10px;
  }

  .title {
    margin-bottom: 10px;
  }
}
</style>
